import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-ng2-select2-bootstrap',
  template: `
    <p>
      ng2-select2-bootstrap works!
    </p>
  `,
  styles: []
})
export class Ng2Select2BootstrapComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
